// extracted by mini-css-extract-plugin
export default {"authLayout":"Login_authLayout__vbCU+","titleHeader":"Login_titleHeader__4HlZD"};